// 🔧 ticket_report.js
// ✅ Purpose: Builds standardized reports for Ticket Demo Engine
// ✅ Features:
// - Reports ticket types created
// - Reports tickets created
// - Reports checked-in ticket count
// - Returns Demo Report v2-compatible structured results
// - Fully block-commented for clarity and future devs

export const buildTicketReport = ({
  ticketResults,
} = {}) => {
  const ticketTypes = ticketResults?.ticketTypes || [];
  const tickets = ticketResults?.tickets || [];

  const checkedInCount = tickets.filter(
    (ticket) => ticket.checkInStatus === "checked_in"
  ).length;

  return {
    success: true,

    created: {
      ticketTypes: ticketTypes.length,
      tickets: tickets.length,
      checkedInTickets: checkedInCount,
    },

    summary: [
      `${ticketTypes.length} Ticket Types`,
      `${tickets.length} Tickets`,
      `${checkedInCount} Checked In`,
    ].join(" • "),
  };
};